import "@texada/views-and-export/styles.css";
import "@texada/ui/styles.css";

import "./deprecated/select.scss";
import "./deprecated/forms.scss";
import "./deprecated/tables.scss";
import "./deprecated/modals.scss";
import "./deprecated/semantic.scss";

import "./animations.scss";
import "./layout.scss";
import "./helpers.scss";
import "./scrollbar.scss";
import "./base.scss";
